import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const contentWithBgImageCss = css`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const arDownloadLinkCardCss = css`
  border-radius: 8px;
  overflow: hidden;

  /* Use dynamic text color based on background brightness for title, subtitle, and body */
  [data-testid='sdsm-content-title'],
  [data-testid='sdsm-content-subtitle'] {
    color: var(--custom-text-color);
  }

  /* Apply to body but exclude the entire CTA container */
  .sdsm-content-body > *:not([data-testid='sdsm-content-cta']) {
    color: var(--custom-text-color);
  }

  .sdsm-content-body > *:not([data-testid='sdsm-content-cta']) * {
    color: var(--custom-text-color);
  }

  /* Make all text in the card bolder except buttons/links */
  &.sdsm-content *:not([class*='button']):not(a) {
    font-weight: 600;
  }

  [data-testid='sdsm-content-media'] {
    transform: translateY(${m('--spacing-m')});
  }

  /* Reduce gap only when body text is present */
  [data-testid='sdsm-content-header-and-body']:has([data-testid='sdsm-content-body-content']) {
    gap: ${m('--spacing-xxs')};
  }

  .sdsm-content-body {
    gap: ${m('--spacing-s')};
  }
`;

export const createCustomButtonStylesCss = (color: string, textColor: string) => css`
  /* Override all button types to use custom color */
  &.sdsm-content a[class*='button'] {
    background-color: ${color};
    border: 2px solid ${color};
    color: ${textColor};
    padding: 11px 31px;
    border-radius: 64px;
  }

  &.sdsm-content a[class*='button']:hover {
    background-color: ${color};
    border-color: ${color};
    color: ${textColor};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }

  &.sdsm-content a[class*='button']:active {
    background-color: ${color};
    border-color: ${color};
    color: ${textColor};
    transform: translateY(-1px);
  }
`;
